<div class="container">
  <app-navbar></app-navbar>
  <app-webdziekanat></app-webdziekanat>
</div>